document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("QuickAddModal");
  if (!modal) return;

  const overlay = modal.querySelector(".QuickAddOverlay");
  const content = modal.querySelector(".QuickAddContent");
  const closeBtn = modal.querySelector(".QuickAddClose");
  const inner = modal.querySelector(".QuickAddInner");
  const images = modal.querySelector(".QuickAddImages");
  const info = modal.querySelector(".QuickAddInfo");
  const title = modal.querySelector(".QuickAddTitle");
  const price = modal.querySelector(".QuickAddPrice");
  const variantsWrap = modal.querySelector(".QuickAddVariants");
  const imageList = modal.querySelector(".QuickAddImageList");
  const submitBtn = modal.querySelector(".QuickAddSubmit");

  let selectedVariantId = null;
  let busy = false;
  let inventoryMap = {};

  function css(el, styles) {
    if (!el) return;
    Object.entries(styles).forEach(([key, value]) => {
      el.style.setProperty(key, value, "important");
    });
  }

  function isMobileView() {
    return window.matchMedia("(max-width: 749px)").matches;
  }

  function mountQuickAddButtons() {
  document.querySelectorAll(".ProductItem").forEach(function (item) {
    const button = item.querySelector(".QuickAddButton");
    const imageBox = item.querySelector(".AspectRatio");

    if (!button || !imageBox) return;

    if (button.parentElement !== imageBox) {
      imageBox.appendChild(button);
    }

    css(imageBox, {
      position: "relative",
      overflow: "hidden"
    });

    css(button, {
      position: "absolute",
      right: isMobileView() ? "10px" : "14px",
      bottom: isMobileView() ? "10px" : "14px",
      width: isMobileView() ? "44px" : "48px",
      height: isMobileView() ? "44px" : "48px",
      "border-radius": "999px",
      background: "#00895f",
      color: "#fff",
      display: "flex",
      "align-items": "center",
      "justify-content": "center",
      "font-size": "28px",
      "line-height": "1",
      "z-index": "1",
      "box-shadow": "0 8px 22px rgba(0,0,0,.18)"
    });

    const plus = button.querySelector("span");

    if (plus) {
      css(plus, {
        position: "relative",
        top: "-1px"
      });
    }
  });
}

mountQuickAddButtons();
window.addEventListener("resize", mountQuickAddButtons);

  function openModal() {
    const isMobile = isMobileView();

    modal.classList.remove("hidden");
    modal.classList.add("is-open");

    css(modal, {
      display: "block",
      position: "fixed",
      inset: "0",
      width: "100vw",
      height: "100vh",
      "z-index": "2147483647"
    });

    css(overlay, {
      display: "block",
      position: "fixed",
      inset: "0",
      background: "rgba(0,0,0,.42)",
      "backdrop-filter": "blur(2px)",
      "z-index": "1"
    });

    css(closeBtn, {
      display: "flex",
      position: "absolute",
      top: isMobile ? "18px" : "22px",
      right: isMobile ? "18px" : "22px",
      width: isMobile ? "44px" : "42px",
      height: isMobile ? "44px" : "42px",
      "border-radius": "50%",
      border: "1px solid rgba(0,0,0,.22)",
      background: "#fff",
      "font-size": "0",
      "align-items": "center",
      "justify-content": "center",
      "z-index": "5",
      "box-shadow": "0 10px 28px rgba(0,0,0,.12)"
    });

    closeBtn.innerHTML = `
      <span style="position:absolute;width:18px;height:2px;background:#111;transform:rotate(45deg);border-radius:2px;"></span>
      <span style="position:absolute;width:18px;height:2px;background:#111;transform:rotate(-45deg);border-radius:2px;"></span>
    `;

    if (isMobile) {
      css(content, {
        display: "block",
        position: "fixed",
        left: "0",
        right: "0",
        bottom: "0",
        top: "auto",
        width: "100vw",
        "max-height": "74vh",
        background: "#fff",
        "border-radius": "28px 28px 0 0",
        overflow: "auto",
        transform: "none",
        "z-index": "2",
        padding: "0",
        "box-shadow": "0 -18px 60px rgba(0,0,0,.22)"
      });

      css(inner, { display: "block" });

      css(images, {
        display: "block",
        width: "100%",
        padding: "14px 0 0",
        background: "#fff"
      });

      css(imageList, {
        display: "block",
        width: "100%"
      });

      css(info, {
        display: "block",
        width: "100%",
        padding: "18px 20px 22px",
        background: "#fff"
      });
    } else {
      css(content, {
        display: "block",
        position: "fixed",
        left: "50%",
        top: "50%",
        width: "860px",
        "max-width": "calc(100vw - 40px)",
        "max-height": "82vh",
        background: "#fff",
        "border-radius": "18px",
        overflow: "hidden",
        transform: "translate(-50%, -50%)",
        "z-index": "2",
        padding: "0",
        "box-shadow": "0 24px 80px rgba(0,0,0,.24)"
      });

      css(inner, {
        display: "grid",
        "grid-template-columns": "36% 64%"
      });

      css(images, {
        display: "block",
        height: "100%",
        "max-height": "82vh",
        "overflow-y": "auto",
        background: "#fff",
        padding: "20px"
      });

      css(info, {
        display: "block",
        width: "100%",
        padding: "72px 48px 48px",
        background: "#fff"
      });
    }
  }

  function closeModal(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    modal.classList.add("hidden");
    modal.classList.remove("is-open");
    modal.setAttribute("style", "");
    content.setAttribute("style", "");
    overlay.setAttribute("style", "");
  }

  async function addToCart(variantId) {
    return fetch((window.Shopify?.routes?.root || "/") + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    });
  }

  function getStockNotice() {
    let stockNotice = modal.querySelector(".QuickAddStockNotice");

    if (!stockNotice) {
      stockNotice = document.createElement("div");
      stockNotice.className = "QuickAddStockNotice";
      price.insertAdjacentElement("afterend", stockNotice);
    }

    return stockNotice;
  }

  function updateStockNotice(variant) {
    const stockNotice = getStockNotice();
    const qty = Number(inventoryMap[String(variant.id)] || 0);

    if (variant.available && qty > 0 && qty < 5) {
      stockNotice.innerHTML = `<span></span> Kun ${qty} tilbage i denne størrelse`;
      stockNotice.style.display = "inline-flex";
    } else {
      stockNotice.style.display = "none";
    }

    css(stockNotice, {
      display: stockNotice.style.display,
      "align-items": "center",
      gap: "8px",
      width: "fit-content",
      margin: "0 0 18px",
      padding: "9px 14px",
      "border-radius": "999px",
      background: "#fff4e8",
      color: "#9a4b00",
      "font-size": isMobileView() ? "12px" : "13px",
      "font-weight": "700",
      "line-height": "1"
    });

    const dot = stockNotice.querySelector("span");

    if (dot) {
      css(dot, {
        width: "8px",
        height: "8px",
        "border-radius": "50%",
        background: "#f59e0b",
        "box-shadow": "0 0 0 4px rgba(245,158,11,.18)",
        display: "block",
        "flex-shrink": "0"
      });
    }
  }

  function styleModalText() {
    const isMobile = isMobileView();

    css(title, {
      color: isMobile ? "#111" : "#245b4f",
      "font-family": "var(--heading-font-family)",
      "font-size": isMobile ? "15px" : "24px",
      "line-height": isMobile ? "1.35" : "1.22",
      "letter-spacing": isMobile ? "0" : ".10em",
      "text-transform": isMobile ? "none" : "uppercase",
      "font-weight": isMobile ? "500" : "700",
      margin: isMobile ? "4px 62px 12px 0" : "0 0 20px"
    });

    css(price, {
      color: "#111",
      "font-size": isMobile ? "16px" : "22px",
      "font-weight": "700",
      margin: isMobile ? "0 0 12px" : "0 0 16px",
      "line-height": "1.2"
    });
  }

  function renderImages(product) {
    const isMobile = isMobileView();
    imageList.innerHTML = "";

    if (isMobile) {
      imageList.insertAdjacentHTML(
        "beforeend",
        `<img src="${product.images[0]}" alt="" style="width:82px;height:82px;object-fit:contain;display:block;margin:0 auto;">`
      );
      return;
    }

    product.images.forEach(function (image) {
      imageList.insertAdjacentHTML(
        "beforeend",
        `<img src="${image}" alt="" style="width:100%;height:240px;object-fit:contain;display:block;background:#fff;margin-bottom:6px;">`
      );
    });
  }

  function renderVariants(product) {
    variantsWrap.innerHTML = "";
    selectedVariantId = null;

    product.variants.forEach(function (variant) {
      if (!variant.available) return;

      const variantBtn = document.createElement("button");
      variantBtn.type = "button";
      variantBtn.className = "QuickAddVariantButton";
      variantBtn.textContent = variant.title;

      if (!selectedVariantId) {
        selectedVariantId = variant.id;
        variantBtn.classList.add("is-active");
        updateStockNotice(variant);
      }

      css(variantBtn, {
        height: isMobileView() ? "48px" : "56px",
        padding: "0 14px",
        "border-radius": "14px",
        border: "1px solid transparent",
        background: variantBtn.classList.contains("is-active") ? "#111" : "#f4f4f4",
        color: variantBtn.classList.contains("is-active") ? "#fff" : "#111",
        "font-size": isMobileView() ? "14px" : "15px",
        "font-weight": "600",
        "transition": "all .18s ease"
      });

      variantBtn.addEventListener("click", function (event) {
        event.preventDefault();

        variantsWrap.querySelectorAll(".QuickAddVariantButton").forEach(function (btn) {
          btn.classList.remove("is-active");
          btn.style.background = "#f4f4f4";
          btn.style.color = "#111";
        });

        variantBtn.classList.add("is-active");
        variantBtn.style.background = "#111";
        variantBtn.style.color = "#fff";

        selectedVariantId = variant.id;
        updateStockNotice(variant);
      });

      variantsWrap.appendChild(variantBtn);
    });

    css(variantsWrap, {
      display: "grid",
      "grid-template-columns": "repeat(2, 1fr)",
      gap: isMobileView() ? "10px" : "12px",
      "margin-bottom": isMobileView() ? "18px" : "24px"
    });
  }

  function styleSubmitButton() {
    css(submitBtn, {
      width: "100%",
      height: isMobileView() ? "54px" : "58px",
      "border-radius": "999px",
      background: "#00895f",
      color: "#fff",
      "font-size": isMobileView() ? "14px" : "15px",
      "font-weight": "800",
      "letter-spacing": ".12em",
      "text-transform": "uppercase",
      "box-shadow": "0 14px 34px rgba(0,137,95,.25)"
    });
  }

  async function handleQuickAdd(e) {
    const button = e.target.closest(".QuickAddButton");
    if (!button || busy) return;

    e.preventDefault();
    e.stopPropagation();

    const hasVariants = button.dataset.hasVariants === "true";

    if (!hasVariants) {
      busy = true;
      await addToCart(button.dataset.variantId);
      button.classList.add("is-added");
      setTimeout(() => button.classList.remove("is-added"), 1000);
      busy = false;
      return;
    }

    try {
      inventoryMap = JSON.parse(button.dataset.variantInventory || "{}");
    } catch (error) {
      inventoryMap = {};
    }

    selectedVariantId = null;

    title.textContent = "Indlæser...";
    price.textContent = "";
    variantsWrap.innerHTML = "";
    imageList.innerHTML = "";
    getStockNotice().style.display = "none";

    openModal();

    const response = await fetch("/products/" + button.dataset.productHandle + ".js");
    const product = await response.json();

    title.textContent = product.title;
    price.textContent = (product.price / 100).toLocaleString("da-DK", {
      style: "currency",
      currency: "DKK"
    });

    styleModalText();
    renderImages(product);
    renderVariants(product);
    styleSubmitButton();
  }

  document.addEventListener("click", handleQuickAdd, true);

  closeBtn.addEventListener("click", closeModal, true);
  overlay.addEventListener("click", closeModal, true);

  submitBtn.addEventListener("click", async function (e) {
    e.preventDefault();

    if (!selectedVariantId || busy) return;

    busy = true;
    submitBtn.textContent = "Tilføjer...";

    await addToCart(selectedVariantId);

    submitBtn.textContent = "Tilføjet ✓";

    setTimeout(function () {
      submitBtn.textContent = "Tilføj til kurv";
      closeModal(e);
      busy = false;
    }, 700);
  });
});